var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.icons},_vm._l((_vm.icons),function(icon,idx){
var _obj;
return _c('div',{key:icon,class:( _obj = {}, _obj[_vm.$style.iconWrap] = true, _obj[_vm.$style.last] = idx === _vm.icons.length - 1 && idx !== 0, _obj ),style:({
      width: ((Math.ceil(100/_vm.icons.length)) + "%")
    })},[_c('SvgImage',{class:_vm.$style.icon,attrs:{"icon":icon,"width":"30","height":"38"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }